module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/4DJr6H/CoverDesign.jpg?1684886421244",
      "alt": "This image is the cover for the book Heart of a Redneck"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Heart of a Redneck\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Colby McBride is a blue-collar cowboy trying to make ends meet laying tile in Colorado. A loner by choice, Colby works hard with his hands and finds his peace camping in the mountains outside Boulder. Gordon James is a white-collar restaurateur who owns not one, but two successful establishments in downtown Boulder. He’s a sophisticated urbanite who is devoted to his work and is accustomed to getting what he wants.")]), _vm._v(" "), _c('p', [_vm._v("The men are friends, but sparks fly when Colby falls in love and decides to show Gordon how much fun a good old boy can be. They’re just beginning to explore their relationship when Gordon’s sister’s suicide leaves him with custody of his five-year-old niece. ")]), _vm._v(" "), _c('p', [_vm._v("Colby comes from a huge family and is eager to help with the girl and to prove his worth to Gordon. But neither of them is ready for the tremendous changes to their already busy lives, or for how this new relationship with Olivia challenges them, complicating the way they interact with each other. ")]), _vm._v(" "), _c('p', [_vm._v("They say opposites attract, but can these two very different men work together to join their disparate lives and form a strong, if highly unlikely, family? ")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jodi Payne, BA Tortuga\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Dreamspinner Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0